export default __webpack_public_path__ + "static/media/offwhitebanner2.cd214d72.jpg";